import { connect } from 'react-redux';

import {
  GET_MY_PLACE,
  GET_PLACE_DETAIL,
  GET_PLACE_TODAY_BOOKING,
  UPDATE_PLACE,
} from 'store/place/actionTypes';
import { GET_DISTRICT_LIST, GET_PROVINCE_LIST, GET_WARD_LIST } from 'store/address/actionTypes';

import Home from './Home';

const mapStateToProps = (state) => ({
  myPlace: state.Place.myPlace,
  placeDetail: state.Place.placeDetail,
  placeTodayBooking: state.Place.placeTodayBooking,
  isLoadingGetPlaceTodayBooking: state.Place.isLoadingGetPlaceTodayBooking,
  isLoadingUpdatePlace: state.Place.isLoadingUpdatePlace,
  provinces: state.Address.provinces,
  districts: state.Address.districts,
  wards: state.Address.wards,
  // Intranet modules[] (same source the sidebar gates on); an extranet accountSetting object
  // here just means the flight module check below is false, no separate branch needed.
  myPermission: state.Administrator.myPermission,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetMyPlace: (payload) => dispatch({
    type: GET_MY_PLACE,
    payload,
  }),
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),
  actionGetPlaceTodayBooking: (payload) => dispatch({
    type: GET_PLACE_TODAY_BOOKING,
    payload,
  }),
  actionUpdatePlace: (payload) => dispatch({
    type: UPDATE_PLACE,
    payload,
  }),
  actionGetProvinceList: (payload) => dispatch({
    type: GET_PROVINCE_LIST,
    payload,
  }),
  actionGetDistrictList: (payload) => dispatch({
    type: GET_DISTRICT_LIST,
    payload,
  }),
  actionGetWardList: (payload) => dispatch({
    type: GET_WARD_LIST,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
